import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Stack, Typography } from '@mui/material'

import TableView, { useTable } from 'packages/ui/Table'

import { parseCsv } from './csv'
import { tableContainerSx } from './ImportStyles'

const PREVIEW_COLUMNS = [
  {
    name: 'name',
    header: { label: context => context.t('ran.table.label') },
    style: { width: '35%' },
    value: space => space.name || '-'
  },
  {
    name: 'vlan',
    header: { label: context => context.t('ran.import.vlan') },
    value: space => space.vlan || '-',
    withPsk: true
  },
  {
    name: 'passphrase',
    header: { label: context => context.t('ran.import.passphrase') },
    value: space => space.passphrase || '-',
    withPsk: true
  },
  {
    name: 'description',
    header: { label: context => context.t('ran.table.description') },
    value: space => space.description || '-'
  }
]

const StepPreview = ({ data, withPsk }) => {
  const { t } = useTranslation()
  const content = useMemo(() => parseCsv(data, withPsk), [data, withPsk])

  const apiTable = useTable({
    rowKey: 'id',
    loading: false,
    items: content,
    columns: PREVIEW_COLUMNS.filter(column => withPsk || !column.withPsk)
  })

  return (
    <Stack sx={{ gap: 2, height: '100%', minHeight: 0 }}>
      <Typography sx={{ color: 'grey.800', fontSize: 13, fontWeight: 500, flexShrink: 0 }}>
        {t('ran.import.spaces_count_to_create', { count: content.length })}
      </Typography>
      <Box sx={tableContainerSx}>
        <TableView apiTable={apiTable} />
      </Box>
    </Stack>
  )
}

export default StepPreview
